import { Button, Eyebrow } from './atoms'
import { resolveImageUrl } from '../lib/api'
import type { HeroRow } from '../lib/types'

function scrollTo(id: string) {
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' })
}

export function Hero({ hero }: { hero: HeroRow | null }) {
  if (!hero) return null
  return (
    <section className="ax-hero" style={{
      position: 'relative', minHeight: 720,
      background: 'var(--ink)', color: 'var(--fg-inverse)', overflow: 'hidden',
    }}>
      {hero.image_key && (
        <img src={resolveImageUrl(hero.image_key)} alt=""
             style={{
               position: 'absolute', inset: 0, width: '100%', height: '100%',
               objectFit: 'cover', opacity: 0.55,
             }} />
      )}
      <div style={{
        position: 'absolute', inset: 0,
        background: 'linear-gradient(180deg, rgba(15,15,16,0.55) 0%, rgba(15,15,16,0.35) 40%, rgba(15,15,16,0.92) 100%)',
      }} />
      <div style={{
        position: 'absolute', inset: 0, pointerEvents: 'none',
        mixBlendMode: 'overlay',
        backgroundImage:
          'radial-gradient(ellipse at 30% 20%, rgba(255,255,255,0.05), transparent 55%), ' +
          'radial-gradient(ellipse at 80% 80%, rgba(0,0,0,0.3), transparent 60%)',
      }} />

      <div className="ax-hero-inner" style={{
        position: 'relative', zIndex: 2,
        padding: '200px 48px 96px',
        maxWidth: 1280, margin: '0 auto',
      }}>
        {hero.eyebrow && <Eyebrow light>{hero.eyebrow}</Eyebrow>}
        <h1 style={{
          fontFamily: 'var(--font-display)', fontWeight: 500,
          textTransform: 'uppercase', letterSpacing: '0.04em',
          fontSize: 'clamp(88px, 11vw, 176px)', lineHeight: 0.94,
          margin: '28px 0 28px',
        }}>{hero.title}</h1>
        {hero.lead && (
          <p className="ax-hero-lead" style={{
            fontFamily: 'var(--font-serif)', fontStyle: 'italic', fontWeight: 400,
            fontSize: 30, lineHeight: 1.25,
            margin: '0 0 40px', maxWidth: 640, color: 'var(--fg-inverse)',
            whiteSpace: 'pre-line',
          }}>{hero.lead}</p>
        )}
        {hero.intro && (
          <p className="ax-hero-intro" style={{
            fontFamily: 'var(--font-body)', fontSize: 17, lineHeight: 1.55,
            maxWidth: 520, margin: '0 0 44px', color: 'var(--fg-inverse-muted)',
          }}>{hero.intro}</p>
        )}
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
          {hero.cta_primary && (
            <Button variant="primary" href="#singoli"
                    onClick={(e) => { e.preventDefault(); scrollTo('singoli') }}>
              {hero.cta_primary}
            </Button>
          )}
          {hero.cta_secondary && (
            <Button variant="ghostLight" href="#live"
                    onClick={(e) => { e.preventDefault(); scrollTo('live') }}>
              {hero.cta_secondary}
            </Button>
          )}
        </div>
      </div>

      {hero.member_line && (
        <div className="ax-hero-member" style={{
          position: 'absolute', bottom: 32, left: 48, zIndex: 2,
          fontFamily: 'var(--font-body)', fontSize: 11,
          letterSpacing: '0.2em', textTransform: 'uppercase',
          color: 'var(--fg-inverse-muted)',
        }}>{hero.member_line}</div>
      )}
      <div className="ax-hero-scroll" style={{
        position: 'absolute', bottom: 32, right: 48, zIndex: 2,
        fontFamily: 'var(--font-body)', fontSize: 11,
        letterSpacing: '0.2em', textTransform: 'uppercase',
        color: 'var(--fg-inverse-muted)',
      }}>Scroll ↓</div>
    </section>
  )
}
